import React, { useEffect, useRef, useState } from 'react';
import { getMes } from '@portal-internet/core';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './compteEnrere.module.scss';

const _getFormatData = (date, time) => {
    const getTimestamp = () => {
        const [day, month, year] = date.split('/').map(Number);
        const [hours, minutes] = time.split(':').map(Number);
        return new Date(year, month - 1, day, hours, minutes, 0, 0);
    };

    return {
        dia: date.split('/')?.[0] || '',
        mes: getMes(date, 'de'),
        hora: time,
        date: getTimestamp()
    };
};

const _getTimeStep = (stale) => {
    const second = 1000;
    const minute = 60 * second;
    const hour = 60 * minute;
    const day = 24 * hour;

    switch (stale) {
        case 'minuts':
            return minute;
        case 'hores':
            return hour;
        case 'dies':
            return day;
        case 'segons':
        default:
            return second;
    }
};

const _getSteps = (compteEnrere) => {
    const steps = ['dies', 'hores', 'minuts', 'segons'];
    const index = steps.indexOf(compteEnrere);
    if (index === -1) return [];
    return steps.slice(0, index + 1);
};

const _breakdownTime = (ms) => {
    if (typeof ms !== 'number' || ms <= 0) {
        return {
            dies: 0,
            hores: 0,
            minuts: 0,
            segons: 0
        };
    }

    const second = 1000;
    const minute = 60 * second;
    const hour = 60 * minute;
    const day = 24 * hour;

    const dies = Math.floor(ms / day);
    ms -= dies * day;

    const hores = Math.floor(ms / hour);
    ms -= hores * hour;

    const minuts = Math.floor(ms / minute);
    ms -= minuts * minute;

    const segons = Math.floor(ms / second);

    return { dies, hores, minuts, segons };
};

const StepCompteEnrere = (props) => {
    const { remainingTime, step, estil } = props;
    const pad = (n) => String(n).padStart(2, '0');

    const stylesStepCompteEnrere = clsx({
        [styles.stepCompteEnrere]: true,
        [styles[estil]]: !!estil
    });
    return (
        <div className={stylesStepCompteEnrere}>
            <span className={styles.temps}>{pad(remainingTime[step])}</span>
            <span className={styles.nomStep}>{step}</span>
        </div>
    );
};

const CompteEnrere = (props) => {
    const { mostrar, dataEvent, horaEvent, estil, tipus, className, compteEnrere = 'segons' } = props;

    const timeStep = _getTimeStep(compteEnrere);
    const steps = _getSteps(compteEnrere);
    const [remainingTime, setRemainingTime] = useState(false);
    const timer = useRef();
    const formatData = !__isEmpty(dataEvent) && !__isEmpty(horaEvent) ? _getFormatData(dataEvent, horaEvent) : null;

    const stylesCompteEnrere = clsx({
        [styles.contentCompteEnrere]: true,
        [styles[tipus]]: !!tipus,
        [className]: !!className
    });

    useEffect(() => {
        if (!formatData) return;
        const setRemaining = () => {
            const remaining = formatData.date - Date.now();
            setRemainingTime(_breakdownTime(remaining));
        };
        setRemaining();
        timer.current = setInterval(setRemaining, timeStep);

        return () => {
            clearInterval(timer.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (mostrar === false || __isEmpty(dataEvent) || __isEmpty(horaEvent)) return null;

    return (
        <>
            {mostrar && remainingTime && (
                <div className={stylesCompteEnrere}>
                    {steps.map((step, i) => (
                        <React.Fragment key={`compte-enrere-${step}`}>
                            <StepCompteEnrere remainingTime={remainingTime} step={step} estil={estil} />
                            {i < steps.length - 1 && <span className={styles.separadorTemps}>:</span>}
                        </React.Fragment>
                    ))}
                </div>
            )}
        </>
    );
};

export default CompteEnrere;
